import React from 'react';

const Logo = ({ className = '', style = {}, alt = 'Trivia Plug Logo', size = 48, variant = 'default' }) => {
  const getLogoClasses = () => {
    let classes = `block select-none ${className}`;
    
    if (variant === 'white' || className.includes('text-white')) {
      classes += ' filter brightness-0 invert';
    }
    
    return classes;
  };

  return (
    <img
      src={process.env.PUBLIC_URL + '/triviaplug-logo.png'}
      alt={alt}
      className={getLogoClasses()}
      style={{ 
        height: size, 
        width: 'auto', 
        objectFit: 'contain',
        flexShrink: 0,
        ...style 
      }}
      draggable={false}
      loading="lazy"
      onError={(e) => {
        console.error('Logo failed to load:', e.target.src);
      }}
    />
  );
};

export default Logo; 